<template>
  <div style="padding:50px" class="modifyPassWord">
    <el-form ref="inforForm" size="small" :model="inforForm" :rules="rule" label-position="left" label-width="82px">
      <el-form-item label="当前账号:">
        {{ name }}
      </el-form-item>
      <el-form-item label="原始密码:" prop="oldPwd" size="small">
        <el-input v-model.trim="inforForm.oldPwd" placeholder="请输入原始密码" show-password="show-password" type="password"
          size="small" clearable style="width:500px" />
      </el-form-item>
      <el-form-item label="新密码:" prop="newPwd" size="small">
        <el-input v-model.trim="inforForm.newPwd" :type="passwordType1"
          placeholder="请设置至少6位登录密码" show-password="show-password" size="small" clearable
          style="width:500px" @input="inputMethod" @keydown.native="keydown($event)">
          <p v-if="passwordType1 == 'text' && inforForm.newPwd" slot="suffix" class="bukejin" @click="showPwd1"></p>
          <p v-if="passwordType1 == 'password' && inforForm.newPwd" slot="suffix" class="nobukejin" @click="showPwd1">
          </p>
        </el-input>
        <!-- <p v-if="noteshow" style="position: absolute;top:54px;font-size:12px;top:28px">
          <span style="color:#e6a23c;">{{ str2 }}</span>
        </p> -->
      </el-form-item>
      <el-form-item label="确认密码:" prop="newPwdconfirm" size="small">
        <el-input v-model.trim="inforForm.newPwdconfirm" :type="passwordType2" placeholder="请再次密码"
          show-password="show-password" size="small" style="width:500px" clearable @input="changeInputValue2()"
          @keydown.native="keydown($event)">
          <p v-if="passwordType2 == 'text' && inforForm.newPwdconfirm" slot="suffix" class="bukejin" @click="showPwd2">
          </p>
          <p v-if="passwordType2 == 'password' && inforForm.newPwdconfirm" slot="suffix" class="nobukejin"
            @click="showPwd2"></p>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="onSubmit">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import request from "@/CommonDP/service/userCenter-service";
import requeslogout from "@/CommonDP/service/login-service";
import { mapState } from "vuex";
import JSEncrypt from "jsencrypt";
import globalParams from "@/CommonDP/utils/globalParams";
export default {
  name: "ModifyPassWorld",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        this.noteshow = false;
        callback(new Error("请输入密码"));
      }else if (value.length < 6 ) {
        this.noteshow = false;
        callback(new Error("密码长度至少6个字符"));
      } else {
        if (this.inforForm.newPwdconfirm !== "") {
          this.$refs.inforForm.validateField("newPwdconfirm");
        }
        this.noteshow = true;
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.inforForm.newPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      inforForm: {
        oldPwd: "",
        newPwd: "",
        newPwdconfirm: ""
      },
      rule: {
        oldPwd: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
        newPwd: [{ required: true, validator: validatePass, trigger: "blur" }],
        newPwdconfirm: [{ required: true, validator: validatePass2, trigger: "blur" }]
      },
      passwordType1: "text",
      passwordType2: "text",
      str2: "",
      noteshow: false
    };
  },
  computed: {
    ...mapState({
      username: (state) => state.user.username
    }),
    name() {
      return this.username;
    }
  },
  methods: {
    inputMethod(value) {
      var strongRegex = new RegExp("^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$", "g");
      var mediumRegex = new RegExp(
        "^(((?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[a-z])(?=.*\\W))|((?=.*[A-Z])(?=.*[0-9])(?=.*\\W))|" + "((?=.*[a-z])(?=.*[0-9])(?=.*\\W))).*$",
        "g"
      );
      var enoughRegex = new RegExp(
        "^(((?=.*[A-Z])|(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[a-z])(?=.*\\W))|" + "((?=.*[0-9])(?=.*\\W))|((?=.*[A-Z])(?=.*\\W))).*$",
        "g"
      );
      if (strongRegex.test(value)) {
        this.str2 = "当前密码强度：强";
      } else if (mediumRegex.test(value)) {
        this.str2 = "当前密码强度：中等";
      } else if (enoughRegex.test(value)) {
        this.str2 = "当前密码强度：弱";
      }
      if (!this.inforForm.newPwd) {
        this.passwordType1 = "text";
      } else {
        this.passwordType1 = "password";
      }
    },
    changeInputValue2() {
      if (!this.inforForm.newPwdconfirm) {
        this.passwordType2 = "text";
      } else {
        this.passwordType2 = "password";
      }
    },
    showPwd1() {
      if (this.passwordType1 === "password") {
        this.passwordType1 = "text";
      } else {
        this.passwordType1 = "password";
      }
    },
    showPwd2() {
      if (this.passwordType2 === "password") {
        this.passwordType2 = "text";
      } else {
        this.passwordType2 = "password";
      }
    },
    keydown(event) {
      if (event.keyCode === 32) {
        event.returnValue = false;
      }
    },
    async onSubmit() {
      await this.$refs.inforForm.validate();
      const { oldPwd, newPwd } = this.inforForm;
      const params = {
        oldPwd: this.encPwd(oldPwd),
        newPwd: this.encPwd(newPwd)
      };
      const res = await request.changePassword(params);
      if (res.result === "0") {
        requeslogout.logout();
        this.$router.replace("/");
        this.$message.info("修改成功,请重新登录");
      }
    },
    encPwd(data) {
      if (!data) {
        return;
      }
      if (data.startsWith("_XXX_")) {
        return;
      }
      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(globalParams.get("login.pwd.encRsaPublicKey", ""));
      const encrypted = encrypt.encrypt(data);
      return globalParams.get("login.pwd.encryptedPwdPrefix", "") + encrypted;
    }
  }
};
</script>

<style lang="scss">
.modifyPassWord {
  .el-form-item__content {
    height: 40px;
  }
}
</style>
